export const TRENDS = {
  page: 'trends-page',
  patientList: 'trends-patient-list',
  patientCard: 'trends-patient-card',
  emptyState: 'trends-empty-state',
  chartsGrid: 'trends-charts-grid',
  markerChart: 'trends-marker-chart',
  exportButton: 'trends-export-button',
};
